// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import 'moment/locale/ko';
import './BannerCard.scss';
import { resizeImage } from '../../../lib/common';

type Props = {
  id: string,
  thumbnail: string,
  username: string,
  title: string,
  body: string,
  urlSlug: string,
  oneColumn?: boolean,
};

const BannerCard = ({ thumbnail, title, body, urlSlug, oneColumn }: Props) => {
  const link = `/@cacheby/banners/${urlSlug}`;
  const imgUrl = resizeImage(thumbnail, 2120, 560);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  return (
    <div className={cx('BannerCard', { 'one-column': oneColumn, empty: !thumbnail })}>
      {thumbnail && <Link to={link} className={cx('thumbnail-wrapper')} style={style}></Link>}
    </div>
  );
};

BannerCard.defaultProps = {
  oneColumn: false,
};

export default BannerCard;



// WEBPACK FOOTER //
// ./src/components/common/BannerCard/BannerCard.js